<joymo-videos-list-base
  [$items]="$items"
  [moduleData]="moduleData"
  [canLoadMore]="canLoadMore"
  [isLoading]="isLoading"
  (loadMore)="loadMore()"
>
</joymo-videos-list-base>
